<template>
  <div>
    <div class="text-center mb-3">
      <img class="mb-3" src="/images/check.svg" alt="plan agendado">
      <p class="mb-0"><strong>Plan pagado</strong></p>
      <p v-if="msisdn">Para el número: <strong>{{ formattedMsisdn }}</strong></p>
    </div>

    <div class="mb-5">
      <taiff-card
        :name="data.payment.tariff.name"
        :include="data.payment.tariff.include"
        :price="safeTariffPrice"
      />
    </div>

    <div class="text-center mb-5">
      <h4 class="lh-4 font-weight-normal activation-message">
        El plan se activará el {{ formattedActivationDate }}
      </h4>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaymentScheduledActivation',
  props: {
    data: Object,
    msisdn: String,
  },
  components: {
    'taiff-card': () => import('@/components/TariffCard.vue'),
  },
  computed: {
    formattedMsisdn() {
      return this.msisdn.toString().substring(2, 3) + ' ' + this.msisdn.toString().substring(3, 7) + ' ' + this.msisdn.toString().substring(7, 11);
    },
    safeTariffPrice() {
      return Number(this.data?.payment?.tariff?.price ?? 0);
    },
    formattedActivationDate() {
      const activateAt = this.data?.payment?.scheduledActivation?.activateAt || this.data?.payment?.nextRenewalDate;
      if (!activateAt) {
        return String(this.data?.payment?.nextRenewalHumanDate || '')
          .trim()
          .replace(/(\d{1,2}:\d{2}):\d{2}\b/, '$1');
      }

      const date = new Date(activateAt);
      if (Number.isNaN(date.getTime())) {
        return String(this.data?.payment?.nextRenewalHumanDate || activateAt)
          .trim()
          .replace(/(\d{1,2}:\d{2}):\d{2}\b/, '$1');
      }

      const months = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ];

      const day = date.getDate();
      const month = months[date.getMonth()];
      const hour = String(date.getHours()).padStart(2, "0");
      const minute = String(date.getMinutes()).padStart(2, "0");

      return `${day} de ${month} a las ${hour}:${minute}`;
    },
  },
}
</script>

<style scoped>
.activation-message {
  font-size: 1.2rem;
}
</style>
